import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlComponent } from 'src/app/control/control.component';
import { AddressComponent } from 'src/app/address/address.component';
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FounderMsgComponent } from 'src/app/founder-msg/founder-msg.component';
import { ContactUsComponent } from 'src/app/contact-us/contact-us.component';



@NgModule({
  declarations: [ControlComponent,AddressComponent,FounderMsgComponent,ContactUsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports :[ControlComponent,AddressComponent,FounderMsgComponent,ContactUsComponent]
})
export class SharedModule { }
